import React from 'react';
import './Exercise.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'

const Exercise = (props) => {
   const { name, img, des, age, time } = props.exercise;
   return (
      <div className='product'>
         <img src={img} alt=""></img>
         <div className='product-info'>
            <p className='product-name'>{name}</p>
            <p>{des}</p>
            <p><small>Age: {age}</small></p>
            <p>Time Required: {time} sec</p>

            <button onClick={() => props.handleAddToCart(props.exercise)} className='btn-cart' >
               <p className='btn-text'>Add to List</p>

               <span><FontAwesomeIcon icon={faAngleDoubleDown}></FontAwesomeIcon></span>
            </button>
         </div>
      </div>
   );
};

export default Exercise;
